import React from 'react';
import { strings } from 'strings';
import { NavLink } from 'react-router-dom';

import { Text } from '../../../../../../../../shared/Typhography';
import { Button, Splash } from '../../../../../../../../shared/Components';
import { Icon } from '../Icon/Icon';
import { ItemContainer } from '../ItemContainer/ItemContainer';

import usePuzzle from './hooks/usePuzzle';
import useArtist from './hooks/useArtist';

interface PuzzleItemProps {
  id: string;
  onRemove: () => void;
  disabled: boolean;
}

const PuzzleItem = ({ id, onRemove, disabled }: PuzzleItemProps) => {
  const { state: puzzleState, data: puzzleData } = usePuzzle({ puzzleId: id });
  const { state: artistState, data: artistData } = useArtist({ artistId: puzzleData?.Publisher });

  return (
    <ItemContainer>
      {(puzzleState === 'loading' || artistState === 'loading') && <Splash />}
      {puzzleData && artistData && (
        <>
          <NavLink to={`/view-puzzle/${id}`} target="_blank">
            <Icon src={puzzleData.iconURL} />
          </NavLink>

          <Text style={{ padding: '17px 0' }} size={1} weight="bold">
            {id}
          </Text>
          <NavLink to={`/view-puzzle/${id}`} target="_blank">
            <Text>{puzzleData.name}</Text>
          </NavLink>
          <NavLink to={`/view-artist/${artistData.uid}`} target="_blank">
            <Text>{artistData.username}</Text>
          </NavLink>
          <Button
            style={{ minWidth: 150 }}
            variant="danger"
            disabled={disabled}
            height={30}
            onClick={onRemove}
          >
            {strings.gameEvent.form.buttons.remove}
          </Button>
        </>
      )}
    </ItemContainer>
  );
};

export default PuzzleItem;
